const calcAttFilters = (temp, data) => {
    const newData = temp
            Object.keys(temp).forEach((item)=> {
                if(temp[item] && temp[item].Type === 'String' && temp[item].Value === ''){
                    delete newData[item]
                    delete temp[item]
                }
                if(temp[item] && temp[item].Type === 'Number' ){
                    if(!temp[item].Min && !temp[item].Max){
                        delete newData[item]
                    }
                    else{
                        newData[item].Min = temp[item].Min || Math.min(...data.filter((a) => a.AttributeJSON[item]).map((b) => b.AttributeJSON[item]))
                        newData[item].Max = temp[item].Max || Math.max(...data.filter((a) => a.AttributeJSON[item]).map((b) => b.AttributeJSON[item]))
                        
                    }
                }
                if(temp[item] && temp[item].Type === 'Date' ){
                    if(!temp[item].MinDate && !temp[item].MaxDate){
                        delete newData[item]
                    }
                    else{
                        newData[item].MinDate = temp[item].MinDate || data.filter((a) => a.AttributeJSON[item]).map((b) => new Date(b.AttributeJSON[item].slice(0,-2))).sort((c, d) => c - d)[0]
                        newData[item].MaxDate = temp[item].MaxDate || data.filter((a) => a.AttributeJSON[item]).map((b) => new Date(b.AttributeJSON[item].slice(0,-2))).sort((c, d) => d - c)[0]
                    }
                }
            })
    return newData
}

export default calcAttFilters